export const profileData = {
  name: "佐佐木明希",
  nameJa: "佐々木あき",
  nameEn: "Sasaki Aki",
  birthDate: "1988-12-24",
  birthPlace: "日本东京都",
  height: "160cm",
  measurements: "B82 / W58 / H86",
  bloodType: "A型",
  hobby: "料理、旅行、读书",
  specialty: "钢琴、书法",
  debutDate: "2015年",
  agency: "T-POWERS",
  bio: "佐佐木明希，1988年12月24日出生于日本东京都，2015年正式出道。凭借清纯外表与成熟魅力的反差气质，出道后迅速获得大量粉丝关注。她在作品中展现了出色的表现力与多样的角色塑造能力，被誉为业界最具实力与人气的女演员之一。不仅在演艺领域取得卓越成就，其真实亲和的性格也让她在社交媒体上拥有极高的人气，是众多粉丝心目中无可替代的存在。",
  socialLinks: {
    twitter: "https://twitter.com",
    instagram: "https://instagram.com",
  },
  stats: {
    totalWorks: 350,
    awards: 12,
    yearsActive: 10,
    fanCount: 1200000,
  },
};